import { forwardRef, type ReactNode } from 'react';
import { FormItem, FormLabel, FormControl, FormMessage, FormDescription } from '~/components/ui/form';
import { type InputProps } from '~/components/ui/input';
import { FormInput } from '../ui/form-input';
export const FormSimpleInput = forwardRef<HTMLInputElement, InputProps & {
  isRequired: boolean;
  label?: string;
  className?: string;
  description?: string | ReactNode;
  hasAlertIcon?: boolean;
  hideMessage?: boolean;
  min?: number;
}>(({
  label,
  isRequired,
  description,
  hasAlertIcon = true,
  hideMessage = false,
  ...props
}, ref) => {
  const FormDescriptionNode = () => {
    if (description) {
      return typeof description === 'string' ? <FormDescription>{description}</FormDescription> : description;
    }
    return null;
  };
  return <FormItem>
      {label && <FormLabel asterisk={isRequired}>{label}</FormLabel>}
      <FormControl>
        <FormInput ref={ref} {...props} />
      </FormControl>
      <FormDescriptionNode />
      {!hideMessage && <FormMessage hasAlertIcon={hasAlertIcon} />}
    </FormItem>;
});
FormSimpleInput.displayName = 'FormSimpleInput';